type Props = { admin: boolean };
export const AdminBadge = ({ admin }: Props) => {
  return <>{admin && <span className="badge badge-primary">スペース管理者</span>}</>;
};
